module.exports = __webpack_public_path__ + "img/icon_service_04.ab7fee22.png";